import { useState, useEffect } from 'react';
import {
  Button,
  InputSelect,
  TextAreaInput,
  DropDown,
} from '@wajeez-web/components/ui';
import { BsCreditCard2Back } from 'react-icons/bs';
import { XIcon } from '@heroicons/react/solid';
import { AiOutlineGift, AiOutlineCopy } from 'react-icons/ai';
import { IoCreateOutline } from 'react-icons/io5';
import { DotsVerticalIcon } from '@heroicons/react/solid';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { environment, getLocalTimeFromUTC } from '@wajeez-web/core/utils';
import { Server } from '@wajeez-web/core/api-base';
import {
  useCustomerSelector,
  CustomerCareActions,
} from '@wajeez-web/stores/customers';
import { useCommonDispatch } from '@wajeez-web/stores/common';

const purchaseSourceOptionList = [
  {
    label: 'Internal',
    value: Server.PurchaseSource.INTERNAL,
  },
  {
    label: 'Offline',
    value: Server.PurchaseSource.OFFLINE,
  },
  {
    label: 'Reward',
    value: Server.PurchaseSource.REWARD,
  },
  {
    label: 'Sales',
    value: Server.PurchaseSource.SALES,
  },
];

const UserGiftsElementForm = ({
  data,
}: {
  data: Server.UserDetailsOutput;
  getData: () => void;
}) => {
  const { giftStatus, gifts, products } = useCustomerSelector(
    (s) => s.customerCare
  );
  const dispatch = useCommonDispatch();
  const [addGift, setAddGift] = useState(false);
  const [conumeGift, setConsumeGift] = useState(false);
  const [boughtGifts, setBoughtGifts] = useState<
    Server.CustomerGiftDashboardOutput[]
  >([]);
  const [selectedProductBody, setSeectedProductBody] = useState<number>(-1);
  const [selectedPurchaseSource, setSelectedpurchesSource] =
    useState<Server.PurchaseSource | null>(null);
  const [consumeGiftCode, setConsumeGiftSorce] = useState('');
  useEffect(() => {
    data.id && getGifts();
  }, [data.id]);

  const getGifts = () => {
    data.id && dispatch(CustomerCareActions.getUserGiftsAsync(data.id));
  };

  useEffect(() => {
    if (selectedPurchaseSource || selectedPurchaseSource === 0) {
      dispatch(
        CustomerCareActions.getProductByPurchaseSourceAndProductTypeAsync({
          PurchaseSource: selectedPurchaseSource,
          ProductType: Server.ProductType.GiftProduct,
        })
      );
    }
  }, [selectedPurchaseSource]);

  return (
    <div className=" space-y-2 mt-2">
      <div className="flex justify-between border-b py-4">
        <div className="text-lg font-bold">
          <ReturnTranslatedText
            origintext="Gifts"
            text={`general.${'Gifts'}`}
          />
        </div>
        <div>
          <DropDown
            name="list"
            list={[
              {
                label: 'Create Gift',
                type: 'action',
                onClick: () => setAddGift(true),
              },
              {
                label: 'Consume Gift',
                type: 'action',
                onClick: () => setConsumeGift(true),
              },
            ]}
            Icon={DotsVerticalIcon}
          />
        </div>
      </div>
      <div className="py-4">
        <div className="space-y-4">
          {addGift && (
            <div className=" space-y-2 py-4 border-b">
              <div className="flex space-s-2">
                <div>
                  <IoCreateOutline className="h-5 w-5" />
                </div>
                <div className=" text-base text-center">
                  <ReturnTranslatedText
                    origintext="Create gift"
                    text={`general.${'Create gift'}`}
                  />
                </div>
                <div
                  onClick={() => setAddGift(false)}
                  className=" text-right justify-end cursor-pointer "
                >
                  <XIcon className="h-5 w-5 text-red-500 hover:text-red-300 " />
                </div>
              </div>
              <div className=" rounded-md shadow-md p-2 space-y-2">
                <InputSelect
                  label={'Purchase Source'}
                  value={
                    selectedPurchaseSource
                      ? purchaseSourceOptionList.find(
                          (ele) => ele.value === selectedPurchaseSource
                        )
                      : undefined
                  }
                  name="PurchaseSource"
                  onChange={(name, value: any) =>
                    setSelectedpurchesSource(value.value)
                  }
                  options={purchaseSourceOptionList}
                />
                <InputSelect
                  label={'Product'}
                  value={
                    selectedProductBody
                      ? products
                          .map((ele: any) => ({
                            value: ele.id,
                            label: `${ele.name} (${ele.purchaseProviderKey})`,
                          }))
                          .find((ele) => ele['value'] === selectedProductBody)
                      : undefined
                  }
                  name="ProductId"
                  onChange={(name, value: any) =>
                    setSeectedProductBody(value.value)
                  }
                  options={products.map((ele: any) => ({
                    value: ele.id,
                    label: `${ele.name} (${ele.purchaseProviderKey})`,
                  }))}
                />
                <div className="flex justify-end pt-2">
                  <Button
                    title="Save"
                    onClick={() => {
                      data.id &&
                        dispatch(
                          CustomerCareActions.createUserGiftAsync({
                            customerId: data.id,
                            productId: selectedProductBody,
                          })
                        ).then(() => {
                          getGifts();
                          setAddGift(false);
                        });
                    }}
                  />
                </div>
              </div>
            </div>
          )}
          {conumeGift && (
            <div className=" space-y-2 py-4 border-b">
              <div className="flex space-s-2">
                <div>
                  <BsCreditCard2Back className="h-5 w-5" />
                </div>
                <div className=" text-base text-center">
                  <ReturnTranslatedText
                    origintext="Consume gift"
                    text={`general.${'Consume gift'}`}
                  />
                </div>
                <div
                  onClick={() => setConsumeGift(false)}
                  className=" text-right justify-end cursor-pointer "
                >
                  <XIcon className="h-5 w-5 text-red-500 hover:text-red-300 " />
                </div>
              </div>
              <div className=" rounded-md shadow-md p-2 space-y-2">
                <TextAreaInput
                  label="Code"
                  name="code"
                  onChange={(name, value) => setConsumeGiftSorce(value)}
                  value={consumeGiftCode}
                />
                <div className="flex justify-end pt-2">
                  <Button
                    title="Save"
                    onClick={() => {
                      data.id &&
                        dispatch(
                          CustomerCareActions.consumeUserGiftAsync({
                            customerId: data.id,
                            code: consumeGiftCode,
                          })
                        ).then(() => {
                          setConsumeGift(false);
                        });
                    }}
                  />
                </div>
              </div>
            </div>
          )}
          <div className="flex space-s-2">
            <div>
              <AiOutlineGift className="h-5 w-5" />
            </div>
            <div className=" text-base text-center">
              <ReturnTranslatedText
                origintext="Bought Gifts"
                text={`general.${'Bought Gifts'}`}
              />
            </div>
          </div>
          <div className="divide-y">
            <div className="grid grid-cols-3 items-center gap-x-2 gap-y-2 py-2 text-center">
              <div>
                <ReturnTranslatedText
                  origintext="Created Date"
                  text={`tables.columnTitles.${'Created Date'}`}
                />
              </div>
              <div>
                <ReturnTranslatedText
                  origintext="Consumed On"
                  text={`tables.columnTitles.${'Consumed On'}`}
                />
              </div>
              <div>
                <ReturnTranslatedText
                  origintext="Code"
                  text={`tables.columnTitles.${'Code'}`}
                />
              </div>
            </div>
            {gifts.map((item) => (
              <div className="flex justify-center items-center py-2 divide-s text-center break-words">
                <div className="w-1/3 px-2 py-2">
                  {getLocalTimeFromUTC(item.createdDate || '')}
                </div>
                <div className="w-1/3 px-2 py-2  ">
                  {(item.consumedOn && getLocalTimeFromUTC(item.consumedOn)) ||
                    '-'}
                </div>
                <div className="flex space-s-1 justify-center w-1/3 px-2 py-2">
                  {item.code || '-'}
                  {item.code && (
                    <AiOutlineCopy
                      onClick={() =>
                        navigator.clipboard.writeText(
                          item.code
                            ? `${environment.REACT_APP_Web_App}/me/gifts/${item.code}`
                            : ''
                        )
                      }
                      className="h-5 w-5 hover:text-primary cursor-pointer"
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserGiftsElementForm;
